import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class IntegrationsProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'integrations'
  public hostname = import.meta.env.VITE_APP_INTEGRATION_URL

  constructor(companyId: string) {
    super({ client_internal_id: companyId })
  }

  oauth(data: any): Promise<any> {
    return this.submit('post', `${this.hostname}/${this.endpoint}/oauth`, data, {})
  }

  connect(data: any): Promise<any> {
    return this.submit('post', `${this.hostname}/${this.endpoint}`, data)
  }

  runActions(id: string | number, action: string, params: object): Promise<any> {
    const data = { company_id: this.parameters.company_id, action, ...params }
    return this.submit('post', `${this.hostname}/${this.endpoint}/${id}/action`, data, {})
  }

  forceImport(id: string): Promise<any> {
    return this.submit('get', `${this.hostname}/${this.endpoint}/${id}/force-import`)
  }

  syncSettings(id: string): Promise<any> {
    return this.submit('post', `${this.hostname}/${this.endpoint}/${id}/action`, {
      action: 'sync-settings',
    })
  }

  orderMapping(id: string, params: object): Promise<any> {
    return this.submit('get', `${this.hostname}/${this.endpoint}/${id}/orders-mappings`, params)
  }

  update(id: string | number, item: object): Promise<any> {
    return this.submit('put', `${this.hostname}/${this.endpoint}/${id}`, item)
  }

  all(): Promise<any> {
    return this.submit(
      'get',
      `${this.hostname}/${this.endpoint}?filter[client_id]=${encodeURIComponent(this.parameters.client_internal_id)}`,
    )
  }

  destroy(id: string): Promise<any> {
    return this.submit('delete', `${this.hostname}/${this.endpoint}/${id}`)
  }
}
